
export const OutOfContentModes = {
  Silence: 'Silence',
  NextBroadcast: 'NextBroadcast',
  PreviousEpisode: 'PreviousEpisode',
  StartStream: 'StartStream',
};
export type OutOfContentMode = keyof typeof OutOfContentModes;

export const MixStartedNavModes = {
  Playlist: 'Playlist',
  StayPut: 'StayPut',
};
export type MixStartedNavMode = keyof typeof MixStartedNavModes;
//(typeof MixStartNavModes)[keyof typeof MixStartNavModes];

export interface ProfileSettingsInterface {
  theme?: string;
  outOfContentMode?: OutOfContentMode;
  mixStartedMode?: MixStartedNavMode;
}
